import { EnvironmentInstance, EnvironmentName, TenantId } from 'src/app/_core/constants/EnvironmentConst';
import { Environment } from 'src/app/_core/models/IEnvironment';

export const environment: Environment = {
  name: EnvironmentName.TB,
  tenantId: TenantId.TRUSTBRIDGE_TEST,
  environmentInstance: EnvironmentInstance.STAGING,
  defaultLanguage: 'en-tb',
  appVersion: require('../../package.json').version,
  production: false,
  url: 'https://staging.givingspace.trustbridgeglobal.com/',
  server: 'https://staging.givingspace.trustbridgeglobal.com/api',
  authServer: 'https://staging.givingspace.trustbridgeglobal.com/api/auth',
  mattermostUrl: 'https://test.mattermost.trustbridgeglobal.com',
  placesApiKey: 'AIzaSyCDVRL0Igtki_L6-xHqyquPHdLZ3D3GpXA',
  recaptchaApiKey: '6Ld9tNYfAAAAAInURAhAM34V5OmNg74xWnH4Ib19',
  favicon: 'assets/env-assets/tb/favicon.ico',
  authBackground: 'assets/env-assets/tb/bg.jpg',
  whiteLogo: 'assets/env-assets/tb/logo-white.png',
  blackLogo: 'assets/env-assets/tb/logo-black-v2.png',
  termsOfUse: 'https://www.trustbridgeglobal.com/terms',
  privacyPolicy: 'https://www.trustbridgeglobal.com/privacy',
  emailAddress: 'admin@trustbridgeglobal.com',
  hasCause: true,
  hasCodeOfConduct: true,
  isEnglishDefault: true,
  authConfig: {
    issuer: 'https://test.sso.benevatech.com/auth/realms/BenevaTechTestSec',
    redirectUri: window.location.origin,
    clientId: 'swiss_test-gs-public',
    responseType: 'code',
    scope: 'openid profile email links',
    showDebugInformation: true,
    disableAtHashCheck: true,
    sessionChecksEnabled: true,
    useSilentRefresh: true,
  },
  keycloakRealm: 'BenevaTechTestSec',
  unleashConfig: {
    clientKey: 'default:development.99f139b1d6ec362fdb9827e2379e7ffd136a75259799582616f86d8b',
    url: 'https://unleash.benevatech.com/api/frontend',
  },
};
